export function getCurrentDate(): Date {
    return new Date();
}

export function getStartOfWeek(date: Date): Date {
    const dayOfWeek = date.getDay(); // 0 (Chủ nhật) -> 6 (Thứ bảy)
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Lùi về thứ 2
    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() + diff);
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
}

export  function getEndOfWeek(date: Date): Date {
    const dayOfWeek = date.getDay();
    const diff = dayOfWeek === 0 ? 0 : 7 - dayOfWeek; // Tiến đến Chủ nhật
    const endOfWeek = new Date(date);
    endOfWeek.setDate(date.getDate() + diff);
    endOfWeek.setHours(23, 59, 59, 999);
    return endOfWeek;
}